export default __webpack_public_path__ + "6ab32ccd61d3873834d69432ae831b58.png";